import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import { Toast } from 'buefy';
import VueScrollTo from "vue-scrollto";
import { VueMaskDirective } from 'v-mask'
import "@/assets/styles/settings.scss";
import "vue-material-design-icons/styles.css";
import cookieconsent from 'vue-cookieconsent-component';

Vue.component('cookie-consent', cookieconsent);

import VueGtm from "vue-gtm";
Vue.use(VueGtm, {
  id: "GTM-KG3M42",
  defer: true, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: ["homepage"], // Don't trigger events for specified router names (case insensitive) (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

Vue.directive('mask', VueMaskDirective);
Vue.use(Buefy);
Vue.use(VueScrollTo);
Vue.use(Toast);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
